// HomePage.js
import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import ErrorSnackbar from '../components/ErrorSnackbar.js';
import SuccessSnackbar from '../components/SuccessSnackbar.js';
import MainLayout from '../layouts/MainLayout.js';
import useSnackbarQueue from '../hooks/useSnackbarQueue.js';
import { artworkAttachmentLabel } from '../utils/artworkAttachmentLabel.js';
import {
    getartwork,
    artwork_post
} from "../services/api.js";
import { toast } from "react-toastify";
export const Home = () => {
    const token = useParams();
    const [artall, setartall] = useState();
    const [proof, setproof] = useState(false);
    const [pdfindex, setpdfindex] = useState(0);
    const [rejectModal, setRejectModal] = useState(false);
    const [rejectReason, setRejectReason] = useState("");
    const [pendingRejectId, setPendingRejectId] = useState(null);
    const getartwork_click = async () => {
        const res = await getartwork(token);
        console.log(res.data.Message);
        
        setartall(res.data.AllData);
    }
    const getartwork_click2 = async () => {
        const res = await getartwork(token);
        console.log(res.data.Message);
        if (res.data.Message == "EXPIRED") {
            setproof(true);
        } else {
            setproof(false);
        }
    }
    const handlepdf = (a) => {
        setpdfindex(a)
        // alert(a);
    }
    const {
        ExceptionError,
        successMessages,
        handleExceptionError,
        handleExceptionSuccessMessages,
        clearErrors,
        clearSuccess,
    } = useSnackbarQueue();
    const artwork_api = async (artworkid, status, comment = "") => {
        try {
            console.log(artall);
            const res = await artwork_post(artworkid, status, artall.OrderData, artall.OrderDetails, comment);
            if (res.status == 200) {
                console.log(res);
                setartall((prv) => {
                    const updatedOrderArtworkAttachment = [...prv.OrderArtworkAttachment];
                    updatedOrderArtworkAttachment[pdfindex] = {
                        ...updatedOrderArtworkAttachment[pdfindex],
                        Approve: status
                    };
                    return {
                        ...prv,
                        OrderArtworkAttachment: updatedOrderArtworkAttachment
                    };
                });
                handleExceptionSuccessMessages("Response submit");
            }
        } catch (error) {
            handleExceptionError("Response not submited");
            console.error("Error fetching data:", error);
        }
    }

    const handleRejectClick = (artworkid) => {
        setPendingRejectId(artworkid);
        setRejectReason("");
        setRejectModal(true);
    }

    const handleRejectSubmit = async () => {
        if (!rejectReason.trim()) return;
        setRejectModal(false);
        await artwork_api(pendingRejectId, 0, rejectReason.trim());
        setPendingRejectId(null);
        setRejectReason("");
    }

    const handleRejectCancel = () => {
        setRejectModal(false);
        setPendingRejectId(null);
        setRejectReason("");
    }
    useEffect(()=> {
        getartwork_click();
        getartwork_click2();
    },[]) 

    return (
        <>
            {proof==false ? (
                <>
        <ErrorSnackbar errorMessages={ExceptionError} onClearErrors={clearErrors} />
        <SuccessSnackbar successMessages={successMessages} onclearSuccess={clearSuccess} />
            <MainLayout orderId={artall?.OrderData}>
            <section className="bebranded_artwork_section">
                <div className="container">
                    <div className="bebranded_artwork_part">
                        <div className="bebranded_artwork_part_list">
                            <h3>Artworks</h3>
                            <div className="artwork_data_wrapper">
                                        {artall?.OrderArtworkAttachment &&  artall?.OrderArtworkAttachment.map((item, index) => (
                                    <div className={`${pdfindex == index && "active "}" artwork_listing "`} onClick={() => handlepdf(index)}>
                                        <span>{artworkAttachmentLabel(item.Attachment)}</span>
                                </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="bebranded_artwork_part bebranded_artwork_part2">
                        <div className="bebranded_artwork_part2_img">
                            {/* <img src="/artbanner.jpg"/> */}
                        <iframe src={`https:///api.bebranded.com.au/${artall?.OrderArtworkAttachment[pdfindex]?.Attachment}`} style={{width:'100%', height: '500px'}}></iframe>
                        </div>
                        <div className="button_div_art">
                            {artall?.OrderArtworkAttachment[pdfindex]?.Approve == 2 && (                            
                            <><button onClick={() => artwork_api(artall?.OrderArtworkAttachment[pdfindex].OrderArtworkAttachmentID, 1)}>Approve</button><button onClick={() => handleRejectClick(artall?.OrderArtworkAttachment[pdfindex].OrderArtworkAttachmentID)}>Reject</button></>
                            )}
                        </div>
                            {artall?.OrderArtworkAttachment[pdfindex]?.Approve == 1 && (
                            <div className="button_div_art" style={{justifyContent:'center', marginTop:'-40px'}}>
                                <><p style={{fontFamily:'poppins', color:'green', textAlign:'center'}}>Artwork approved</p></></div>
                            )}
                            {artall?.OrderArtworkAttachment[pdfindex]?.Approve == 0 && (
                            <div className="button_div_art" style={{justifyContent:'center', marginTop:'-40px'}}>
                                <><p style={{fontFamily:'poppins', color:'red', textAlign:'center'}}>Artwork rejected</p></></div>
                            )}
                    </div>
                </div>
            </section>
            </MainLayout>

            {/* Reject Reason Modal */}
            {rejectModal && (
                <div style={{
                    position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)',
                    display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: '#fff', borderRadius: '10px', padding: '32px',
                        width: '100%', maxWidth: '440px', fontFamily: 'poppins', boxShadow: '0 8px 30px rgba(0,0,0,0.15)'
                    }}>
                        <h3 style={{ margin: '0 0 8px', color: '#222' }}>Reason for Rejection</h3>
                        <p style={{ margin: '0 0 16px', color: '#666', fontSize: '14px' }}>Please provide a reason before rejecting this artwork.</p>
                        <textarea
                            autoFocus
                            rows={4}
                            value={rejectReason}
                            onChange={(e) => setRejectReason(e.target.value)}
                            placeholder="Enter your reason here..."
                            style={{
                                width: '100%', padding: '10px 12px', borderRadius: '6px',
                                border: '1px solid #ccc', fontFamily: 'poppins', fontSize: '14px',
                                resize: 'vertical', boxSizing: 'border-box', outline: 'none'
                            }}
                        />
                        {rejectReason.trim() === "" && (
                            <p style={{ margin: '6px 0 0', color: '#e53935', fontSize: '12px' }}>Reason is required.</p>
                        )}
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px' }}>
                            <button
                                onClick={handleRejectCancel}
                                style={{
                                    padding: '9px 20px', borderRadius: '6px', border: '1px solid #ccc',
                                    background: '#fff', fontFamily: 'poppins', cursor: 'pointer', fontSize: '14px'
                                }}
                            >Cancel</button>
                            <button
                                onClick={handleRejectSubmit}
                                disabled={!rejectReason.trim()}
                                style={{
                                    padding: '9px 20px', borderRadius: '6px', border: 'none',
                                    background: rejectReason.trim() ? '#e53935' : '#f5a5a5',
                                    color: '#fff', fontFamily: 'poppins', cursor: rejectReason.trim() ? 'pointer' : 'not-allowed', fontSize: '14px'
                                }}
                            >Submit Rejection</button>
                        </div>
                    </div>
                </div>
            )}
            </>
            ) : (
                <>
                <div style={{height:'100vh', display:'flex', justifyContent:'center', alignItems:'center'}}>
                            <h1 style={{ fontFamily: 'poppins', color: '#01aef0', textAlign: 'center', fontSize:'40px' }}>Link Expired</h1>
                </div>
                </>
            )}
        </>
    );
};
